var map = {
	"./additive-manufacturing.png": 574,
	"./additive-manufacturing.svg": 146,
	"./basavatarakam_logo.png": 712,
	"./brochures/2026_PhD_Brochure_Final.jpg": 534,
	"./brochures/additive_maufacturing.png": 990,
	"./brochures/ev.png": 648,
	"./brochures/mdi.jpg": 801,
	"./brochures/med_phy.png": 779,
	"./brochures/medical_device_innovation.png": 769,
	"./brochures/opthalmic.jpg": 690,
	"./building2.jpg": 713,
	"./buildings.jpg": 964,
	"./cfhe_logo.png": 463,
	"./igcar_logo.png": 915,
	"./iithlogo_footer.png": 312,
	"./logoiith.png": 708,
	"./lvpei_logo.png": 777,
	"./people/Anurup_Datta.jpg": 583,
	"./people/AvinashEranki.jpg": 23,
	"./people/Saswata_Bhattacharya.jpg": 80,
	"./people/Siva_Rama_Krishna_Vanjari.jpg": 157,
	"./people/Subhradeep_Chatterjee.jpg": 920,
	"./people/harish.jpeg": 21,
	"./people/k-nithyanandan.jpeg": 427,
	"./people/mayur.jpg": 537,
	"./people/prabhat-kumar.jpg": 962,
	"./people/rajalakshmi_p.jpg": 661,
	"./people/renu.png": 959,
	"./people/saurabh-s.jpg": 187,
	"./tihan_logo.png": 207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;